(function () {
  function shouldRemoveHover(product, variantId) {
    const images = product.images.map(img =>
      typeof img === 'string' ? img : img.src
    );
    const variantPositions = {};
    product.variants.forEach(v => {
      const fi = v.featured_image;
      const src = fi ? (typeof fi === 'string' ? fi : fi.src) : null;
      if (src) variantPositions[v.id] = images.indexOf(src);
    });

    const myPos = variantPositions[variantId];

    if (myPos === undefined || myPos === -1) return false;

    const nextPos = myPos + 1;

    if (nextPos >= images.length) return true;

    return Object.entries(variantPositions).some(
      ([id, pos]) => Number(id) !== Number(variantId) && pos === nextPos
    );
  }

  function cleanupHovers() {
    const data = window.VariantifyProductsData;
    if (!data || !data[0] || !data[0].products) return;
    const productsByHandle = {};
    data[0].products.forEach(p => { productsByHandle[p.handle] = p; });

    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(card => {
      if (card.dataset.hoverFixed === '1') return;
      const link = card.querySelector('a.full-unstyled-link');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      const handleMatch = href.match(/\/products\/([^?#\/]+)/);
      const variantMatch = href.match(/[?&]variant=(\d+)/);
      if (!handleMatch || !variantMatch) return;

      const product = productsByHandle[handleMatch[1]];
      if (!product) return;

      if (shouldRemoveHover(product, variantMatch[1])) {
        const imgs = card.querySelectorAll('.media--hover-effect img');
        if (imgs.length > 1) imgs[1].remove();
      }
      card.dataset.hoverFixed = '1';
    });
  }

  function run() { setTimeout(cleanupHovers, 100); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.__hoverFixTimer);
    window.__hoverFixTimer = setTimeout(cleanupHovers, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();